import React from "react";
import { MdAdd, MdDelete, MdDownload } from "react-icons/md";
import { useIntl } from "react-intl";

import { operationGetGlebas } from "~/api";

export const fetchGlebaStartData = async ({
  formatMessage,
  operationId,
  setResponse
}) => {
  try {
    operationGetGlebas(operationId).then(response => {
      const glebasResult = response.data.result;
      setResponse({ result: glebasResult });
    });
  } catch (err) {
    setResponse({
      error: err?.response?.data?.message || formatMessage({ id: "erro-api" })
    });
  }
};

const ADD_AREA_TO_CAR_MODAL = "ADD_AREA_TO_CAR_MODAL";

export const RenderGlebaStart = ({
  loading,
  itemsList,
  selectedGlebaId,
  setSelectedGlebaId,
  handleDownloadArea,
  handleDeleteArea,
  setOpenModal
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {!loading && (
        <div className="gleba-data">
          <span
            className="add-gleba-button"
            onClick={() => setOpenModal(ADD_AREA_TO_CAR_MODAL)}
          >
            <MdAdd size={20} />
            {formatMessage({ id: "cadastrar-gleba" })}
          </span>

          <p className="registered-list-header">
            {formatMessage({ id: "lista-glebas-cadastradas" })}
          </p>

          {!itemsList.length ? (
            <div className="is-12">
              <p>{formatMessage({ id: "nenhuma-gleba-cadastrada" })}</p>
            </div>
          ) : (
            <div className="gleba-list">
              {!loading &&
                itemsList.map((gleba, glebaIndex) => (
                  <span
                    className={`gleba-item ${
                      selectedGlebaId === gleba.id ? "is-area-selected" : ""
                    }`}
                    key={glebaIndex}
                    onClick={() => setSelectedGlebaId(gleba.id)}
                  >
                    {formatMessage({ id: "gleba" })} {glebaIndex + 1} -{" "}
                    {formatMessage({ id: "area" })}{" "}
                    {new Intl.NumberFormat("pt-BR", {
                      maximumFractionDigits: 2
                    }).format(gleba.area_ha)}{" "}
                    ha
                    <div className="gleba-options">
                      <MdDownload
                        className="download"
                        size={20}
                        onClick={() => handleDownloadArea(gleba.id)}
                      />
                      <MdDelete
                        className="trash"
                        size={20}
                        onClick={() => handleDeleteArea(gleba.id)}
                      />
                    </div>
                  </span>
                ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};
